import axios from 'axios'

const getParameters = async () => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/system-parameter`)
  return data
}

const updateParameters = async (indicatorFullDiscountDays) => {
  const { data } = await axios.put(`${process.env.VUE_APP_API}/system-parameter`, {
    indicatorFullDiscountDays
  })
  return data
}

export {
  getParameters,
  updateParameters
}
